var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSimpleEarn = function SvgSimpleEarn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.272 8.317h12.755c1.486.363 4.49 2.042 4.614 5.858h1.265v2.162H20.19c-.266.888-1.177 2.785-2.693 3.272l.7 1.037L16.752 22l-1.444-1.67h-7.06l-1.67 1.535-1.511-1.331 1.037-1.083L2 15.955V13.09h2.144l.805-2.03zm11.13 2.832H10.05v2.232h4.352zM15.367 5.689c0 .547-.12 1.067-.334 1.534h-6.71a3.689 3.689 0 1 1 7.044-1.534M11.678 4.05l-1.416 1.416 1.416 1.416 1.416-1.416z",
    clipRule: "evenodd"
  })));
};
export default SvgSimpleEarn;